import styled from '@emotion/styled'
import { IconButton } from '@mui/material'
import React from 'react'

import { HeartFilledIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/HeartFilledIcon'
import { HeartIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/HeartIcon'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { useUserDetails } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/VendorDetailsSection/hooks/useUserDetails'

export const FavoriteButton = () => {
  const {
    state: { vendor_nid },
    favoriteHouse: { isFavorite, addToFavorites, removeFromFavorites }
  } = useHouseDetail()
  const userDetails = useUserDetails()

  return userDetails?.ua_user_state ? (
    <StyledIconButtonNoText
      data-isfavorite={isFavorite}
      data-sel='btn-fav'
      aria-label='Speichern'
      onClick={() => {
        webtrack({
          category: 'CTA-button',
          action: 'click',
          label: 'favourite-house',
          location: 'image-carousel',
          values: [{ type: 'text', value: '(ICON)' }]
        })
        if (isFavorite) {
          removeFromFavorites()
        } else {
          addToFavorites()
        }
      }}>
      {isFavorite ? (
        <>
          <NoTextIconWrapper>
            <HeartFilledIcon />
          </NoTextIconWrapper>
        </>
      ) : (
        <>
          <NoTextIconWrapper>
            <HeartIcon />
          </NoTextIconWrapper>
        </>
      )}
    </StyledIconButtonNoText>
  ) : (
    <StyledIconButtonNoText
      className='js-request-button'
      data-request-type='house-wizard-item-favourite'
      data-funnel-variant='house-wizard-item-favourite'
      data-sel='btn-fav'
      aria-label='Speichern'
      {...(vendor_nid && { 'data-vendor-nid': vendor_nid })}
      onClick={() =>
        webtrack({
          category: 'CTA-button',
          action: 'click',
          label: 'favourite-house',
          location: 'image-carousel',
          indicates: ['funnel-entry'],
          values: [{ type: 'text', value: '(ICON)' }]
        })
      }>
      <NoTextIconWrapper>
        <HeartIcon />
      </NoTextIconWrapper>
    </StyledIconButtonNoText>
  )
}

const NoTextIconWrapper = styled('div')`
  pointer-events: none;

  & svg {
    margin-right: 0;
    width: 100%;
    height: 100%;
    color: ${({ theme }) => theme.palette.common.black};
  }
`

const StyledIconButtonNoText = styled(IconButton)`
  box-shadow: 0 5px 10px -1px rgb(59 71 104 / 5%), 0 2px 4px -3px #3b4768,
    0 2px 40px 0 rgb(59 71 104 / 5%);
  width: 40px;
  height: 40px;
  font-size: 14px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  z-index: 2;
  border-radius: 0;
  padding: 0;
  &:hover,
  &:active {
    background-color: ${({ theme }) => theme.palette.background.paper};
  }
  color: ${({ theme }) => theme.palette.common.black};
`
